import { DEFAULT_POINT_STATUSES } from 'application/pages/PointsPage/renderer/PointsToolbar/consts';

import { DefaultFiltersType, StreamBindModalState, StreamSetPointsInputState } from './types';

export const DEFAULT_FILTERS: DefaultFiltersType = {
  companyIds: [],
  query: '',
  playingStatuses: DEFAULT_POINT_STATUSES,
  companyTagIds: [],
};

export const DEFAULT_STREAM_BIND_MODAL_STATE: StreamBindModalState = {
  selectedPoints: new Map(),
  disabledPoints: new Map(),
  searchText: '',
  isBindLoading: false,
};

export const DEFAULT_STREAM_SET_POINTS_INPUT_STATE: StreamSetPointsInputState = {
  filter: {},
};
